import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { ApiService } from '../../../../../utility/api.service'

export const fetchOnboarding = createAsyncThunk('onboarding/fetch', async ({ id }, { rejectWithValue }) => {
    const response = await ApiService.get(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/inquiry/${id}`)
    if (!response.success) {
        return rejectWithValue(response.exception)
    }

    return { onboarding: response.data.inquiry }
})

export const updateOnboarding = createAsyncThunk('onboarding/update', async ({ id, payload }, { rejectWithValue }) => {
    const response = await ApiService.post(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/inquiry/${id}`, payload)
    if (!response.success) {
        return rejectWithValue(response.exception)
    }

    return { onboarding: response.data.inquiry }
})

export const createOnboarding = createAsyncThunk('onboarding/create', async ({ payload }, { rejectWithValue }) => {
    const response = await ApiService.post(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/inquiry`, payload)
    if (!response.success) {
        return rejectWithValue(response.exception)
    }

    return { onboarding: response.data.inquiry }
})

const initialState = {
    selectedOnboarding: null,
    loading: false,
    submitting: false,
    error: null
}

const onboardingSlice = createSlice({
    name: 'onboarding',
    initialState,
    reducers: {
        // standard reducer logic, with auto-generated action types per reducer
    },
    extraReducers: {
        [fetchOnboarding.pending]: (state) => {
            state.loading = true
        },
        [fetchOnboarding.fulfilled]: (state, { payload }) => {
            state.selectedOnboarding = payload.onboarding
            state.loading = false
        },
        [fetchOnboarding.rejected]: (state, action) => {
            state.loading = false
            state.error = action
        },

        [updateOnboarding.pending]: (state) => {
            state.submitting = true
        },
        [updateOnboarding.fulfilled]: (state, { payload }) => {
            state.selectedOnboarding = payload.onboarding
            state.submitting = false
        },
        [updateOnboarding.rejected]: (state, action) => {
            state.submitting = false
        },

        [createOnboarding.pending]: (state) => {
            state.submitting = true
        },
        [createOnboarding.fulfilled]: (state, { payload }) => {
            state.selectedOnboarding = payload.onboarding
            state.submitting = false
        },
        [createOnboarding.rejected]: (state, action) => {
            state.submitting = false
        }
    }
})

export default onboardingSlice.reducer